import type { ConfigColor, ConfigColors } from "../../envConfig";

// Always make sure red color is the first in the array (is selected for defaullt color for lines and polygons)
export const defaultColors = [
  { border: "white", fill: [226, 0, 42, 1], hex: "#E2002A", name: "red" },
  {
    border: "white",
    fill: [100, 100, 100, 1],
    hex: "#646464",
    name: "gray-dark",
  },
  { border: "white", fill: [0, 0, 0, 1], hex: "#000000", name: "black" },
  {
    border: "black",
    fill: [255, 255, 255, 1],
    hex: "#ffffff",
    name: "white",
  },
  {
    border: "black",
    fill: [171, 171, 171, 1],
    hex: "#ababab",
    name: "gray-light",
  },

  { border: "white", fill: [30, 0, 125, 1], hex: "#1e007d", name: "blue" },
] as ConfigColor[];

export default {
  colors: defaultColors,
  iconGeneratorColors: defaultColors,
  lineColors: defaultColors,
  polygonFillColors: defaultColors,
  polygonLineColors: defaultColors,
  textBgColors: [
    { fill: [255, 255, 255, 0.01], name: "none" },
    ...defaultColors,
  ],
} as ConfigColors;
